import React from 'react'

import T from 'components/FormattedMessage'
import Paper from 'components/Paper'
import Button from 'components/Button'
import AutoSub from 'components/AutoSub'

import CheckIcon from '@material-ui/icons/Check'

import { withAutoSub, InjectedAutoSubProps } from 'contexts/AutoSub'
import { ackAutosubIntro } from 'services/gamelogic'
import { createStyles, withStyles, WithStyles } from '@material-ui/core'
import config from 'config'

interface Props {
  isActivated?: boolean
  isLoading?: boolean
  onUse: () => void
}

const styles = createStyles({
  activationContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    padding: '6px 0',
  },
  activationIcon: {
    fill: '#fff',
    width: 20,
    height: 20,
  }
})

type InjectedProps = Props & InjectedAutoSubProps & WithStyles<typeof styles>

const MyTeamAutoSub: React.SFC<InjectedProps> = ({
  isAcknowledged,
  remainingSubs,
  isLoading,
  isActivated,
  onStoreClick,
  onUse,
  classes,
}) => {
  if (remainingSubs < 1 && config.IS_STORE_DISABLED && !isActivated) {
    return null
  }

  return (
    <AutoSub
      isActivated={isActivated}
      onStoreClick={onStoreClick}
      ackAutosubIntro={ackAutosubIntro}
      isAcknowledged={isAcknowledged}
      remainingSubs={remainingSubs}
      rightChild={(
        isActivated
          ? (
            <Paper square={false} color="primary" className={classes.activationContainer}>
              <CheckIcon className={classes.activationIcon} />
            </Paper>
          )
          : (
            <Button
              fullWidth
              color="secondary"
              variant="contained"
              size="small"
              disabled={isLoading}
              onClick={remainingSubs < 1 ? onStoreClick : onUse}
            >
              {(
                remainingSubs < 1
                  ? <T id="autosub_action_buy" />
                  : <T id="autosub_action_use" />
              )}
            </Button>
          )
      )}
      message={(
        remainingSubs < 1
          ? <T id="autosub_message_notickets" />
          : <T id="autosub_message_available" />
      )}
    />
  )
}

export default withStyles(styles)(withAutoSub(MyTeamAutoSub))
